const jwt_customizer = {
    general: 'カスタマイズJWTトークン中にエラーが発生しました。後でもう一度お試しください。',
    can_not_create_for_admin_tenant: '管理テナントのJWTトークンカスタマイザを作成できません。',
};
export default Object.freeze(jwt_customizer);
